// src/redux/toastSlice.js
import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
    toasts: [],
};

const toastSlice = createSlice({
    name: "toast",
    initialState,
    reducers: {
        showToast: {
            reducer: (state, action) => {
                state.toasts.push(action.payload);
            },
            prepare: ({ message, type = "success", duration = 3000 }) => ({
                payload: {
                    id: nanoid(),
                    message,
                    type,
                    duration,
                },
            }),
        },
        hideToast: (state, action) => {
            state.toasts = state.toasts.filter(t => t.id !== action.payload);
        },
        clearToasts: (state) => {
            state.toasts = [];
        },
    },
});

export const { showToast, hideToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
